import useHandleProductDocumentation from './Hooks/useHandleProductDocumentation'
import LoadingSpinner from '../Components/LoadingSpinner'
import { CiFileOn } from "react-icons/ci";
import { LuExternalLink } from "react-icons/lu";

import './Styles/ProductDocumentationStyles.css'

const ProductDocumentation = ({ index }) => {
    const { documentFolderStructure, isLoading, handleOpenFile } = useHandleProductDocumentation(index)

    const removeExtension = (fileName) => {
        const idx = fileName.lastIndexOf('.')
        return idx === -1 ? fileName : fileName.substring(0, idx)
    }
    const generateFileComponent = (file, key) => {
        const isLink = file.linkUrl && file.linkUrl.trim() !== '' ? true : false
        return (<div className="col-6">
            <div className='d-flex align-items-center '>
                {isLink ? (<LuExternalLink className='me-1' size={20} />) : (<CiFileOn className='me-1' size={20} />)}
                {isLink ? (<div className='row'>
                    <div className="col-auto">
                        <span className='app-link' onClick={() => window.open(file.linkUrl, '_blank')}>{removeExtension(file.fileName)}</span>
                    </div>
                    <div className="col-auto">
                        {file.expiredDateString.trim() != '' && <span className='secondary-text'>{`Ważdny do: ${file.expiredDateString.replace(/(\d{4})(\d{2})(\d{2})/, "$1-$2-$3")}`}</span>}
                    </div>
                </div>)
                    : (<div className='row'>
                        <div className="col-auto">
                            <span onClick={() => handleOpenFile(file.folderAsLink + '/' + file.fileName)} className='product-documentation-document' key={key}> {removeExtension(file.fileName)}</span>
                        </div>
                        <div className="col-auto">
                            {file.expiredDateString.trim() != '' && <span className='secondary-text'>{`Ważdny do: ${file.expiredDateString.replace(/(\d{4})(\d{2})(\d{2})/, "$1-$2-$3")}`}</span>}
                        </div>
                    </div>)}
            </div>
        </div>)
    }

    if (isLoading) {
        return <LoadingSpinner />
    }
    if (!isLoading && !documentFolderStructure || documentFolderStructure.length === 0) {
        return <div className="container">
            <span>Brak plików dla tego produktu</span>
        </div>
    }
    return (
        <div className="container">
            {documentFolderStructure.map((folder, key) => {
                return (<div key={key} className='d-flex flex-column mb-3'>
                    <b style={{ fontSize: '23px' }}>{folder.folderName}</b>
                    <div key={key} className='row mt-2'>
                        {folder.files.map((file, key) => (
                            generateFileComponent(file, key)
                        ))}
                    </div>
                </div>)
            })}
        </div>
    )
}

export default ProductDocumentation